import { PropTypes } from 'prop-types';
import Card3 from '@/components/layout/espots/Card3';
import Card4 from '@/components/layout/espots/Card4';
import { ESPOT_CARD_TYPE } from '@/constants/espot';
import { formatImageInfoCardListData } from '@/utils/homepageUtils';
import styles from './DuoCardList.module.scss';

const DuoCardList = ({ data }) => (
	<div className={styles.container}>
		{data?.espotsList?.map((item) => {
			switch (item.espot.cardType) {
				case ESPOT_CARD_TYPE.CARD_3:
					return <Card3 key={item._id} data={formatImageInfoCardListData(item.espot)} />;
				case ESPOT_CARD_TYPE.CARD_4:
					return <Card4 key={item._id} data={formatImageInfoCardListData(item.espot)} />;
			}
		})}
	</div>
);

DuoCardList.propTypes = {
	data: PropTypes.shape({
		espotsList: PropTypes.array,
	}),
};

export default DuoCardList;
